import { Form, Modal } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ILoan from '~Api/Loan/ILoan';
import { loanDischargeAction } from '~Loans/actions';
import DatePicker from '~UI/DatePicker';

interface IState {
    dischargeDate: string;
}

interface IProps {
    loan: ILoan;
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsDispatch {
    discharge: (dischargeDate: string) => void;
}

type Props = IProps & IPropsDispatch;

class DischargeModal extends React.Component<Props, IState> {
    public state: IState = {
        dischargeDate: null,
    };

    constructor(props: Props) {
        super(props);

        this.onChangeDischargeDate = this.onChangeDischargeDate.bind(this);
        this.onClickOk = this.onClickOk.bind(this);

        this.state.dischargeDate = dayjs().format('YYYY-MM-DD');
    }

    public render(): JSX.Element {
        const { isOpen } = this.props;
        const { dischargeDate } = this.state;

        return (
            <Modal
                destroyOnClose={true}
                okText='Discharge'
                okType='danger'
                onCancel={this.props.onCancel}
                onOk={this.onClickOk}
                open={isOpen}
                title='Discharge Loan'
                wrapClassName='loan-discharge-modal'
            >
                <Form.Item label='Discharge Date' className='discharge-date'>
                    <DatePicker onChange={this.onChangeDischargeDate} format='DD/MM/YYYY' value={dischargeDate ? dayjs(dischargeDate) : null} />
                </Form.Item>
            </Modal>
        );
    }

    private onChangeDischargeDate(date: Dayjs) {
        this.setState({
            dischargeDate: date ? date.format('YYYY-MM-DD') : null,
        });
    }

    private onClickOk() {
        const { dischargeDate } = this.state;

        this.props.onCancel();

        this.props.discharge(dischargeDate);
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        discharge: (dischargeDate: string) => dispatch(loanDischargeAction(ownProps.loan.uuid, dischargeDate)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(DischargeModal);
